'use client';

import { useMemo } from 'react';
import {
  UpdateSignalEditModal,
  type UpdateSignalData,
} from '../modals/UpdateSignalEditModal';
import { updateSignalHitlConfig } from '../../tools/signal/update-signal-hitl-config';
import type { EditModalProps } from '../../tool-config-types';

export function UpdateSignalEditModalWrapper({
  isOpen,
  onClose,
  onSubmit,
  toolName: _toolName,
  extractedData = [],
}: EditModalProps) {
  const hitlConfig = updateSignalHitlConfig;

  const initialData = useMemo(
    () => (extractedData[0] ?? {}) as UpdateSignalData,
    [extractedData],
  );

  const handleSubmit = (editedData: UpdateSignalData) => {
    if (!hitlConfig) return;
    const wrappedData = hitlConfig.wrapEditedData([editedData]);
    onSubmit(wrappedData);
  };

  if (!isOpen || !initialData.signalId) return null;

  return (
    <UpdateSignalEditModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      initialData={initialData}
    />
  );
}
